import { Store } from 'styled-icons/material'

export interface Props {
  readonly size: number
  readonly style?: React.CSSProperties
}

export function StoreImage({ size, style }: Props & React.ButtonHTMLAttributes<any>) {
  return (
    <div style={style}>
      <Store size={size} />
    </div>
  )
}
